import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { PRICING_TABLE } from "../constants/editor";
import { EditorContext } from "../containers/editor/EditorLayout";
import useProposalCalculator from "./useProposalCalculator";
import { fetchProposalModuleList } from "../store/actions/companyActions";
import { changeBucketColorAccordingBackground, getZoomedValue, hexToRGB } from "../_helpers/utils";

const usePricingTableEvent = () => {
  let { metadata, setShowPricingTableImageCarousel, widgets, updateWidgets, dimension } = useContext(EditorContext);

  const dispatch = useDispatch();

  const [tableConfigData, setTableConfigData] = useState();
  const [discountOptions, setDiscountOptions] = useState();
  const [targetSection, setTargetSection] = useState();
  const [targetSectionIndex, setTargetSectionIndex] = useState();
  const [targetItem, setTargetItem] = useState();
  const [targetItemIndex, setTargetItemIndex] = useState();
  const [currencyInfo, setCurrencyInfo] = useState();

  const {
    sections: calculatedSections,
    grandSubtotal,
    oneLineDiscountAmount,
    detailedTaxes,
    grandTotal,
  } = useProposalCalculator(tableConfigData?.sections, discountOptions);

  const handleImageClick = event => {
    let items = [];
    let dataSrc = event.target.closest(".item-image").getAttribute("data-image-urls");
    let imageArray = dataSrc.split(",");
    imageArray.forEach((img, index) => {
      let newObj = {
        src: img,
        altText: `${index + 1}/${imageArray?.length}`,
      };
      items.push(newObj);
    });
    setShowPricingTableImageCarousel(items);
  };

  const handlePricingtableOptionClick = event => {
    let tableConfig = document.getElementById(metadata.activeWidgetId).getAttribute("data-table-config");
    tableConfig = JSON.parse(tableConfig);
    let target = getClosestSiblingWithSelector(event.target, "input");
    let targetId = target.getAttribute("id");
    let updatedTableConfig;
    let sectionIndex;

    // handle click on section
    if (target.classList.contains("pricing-table-section-input")) {
      sectionIndex = targetId.split("-")[2];
      let sectionType = targetId.split("-")[1] === "sectioncheckbox" ? "checkbox" : "radio";

      //  update html for section click
      if (sectionType === "checkbox") {
        let isChecked = document.getElementById(targetId).checked;
        if (isChecked) document.getElementById(targetId).removeAttribute("checked");
        else document.getElementById(targetId).setAttribute("checked", "");
        document.getElementById(targetId).checked = !isChecked;
      } else {
        document.querySelectorAll(".pricing-table-section-input").forEach(element => {
          element.checked = false;
          element.removeAttribute("checked");
        });
        document.getElementById(targetId).checked = true;
        document.getElementById(targetId).setAttribute("checked", "");
      }

      // disbale other section amount in html
      document.querySelectorAll(".pricing-table-section-input").forEach(element => {
        if (!element.checked) element.closest(".card-header").querySelector(".pricing-amount").classList.add("disable");
        else element.closest(".card-header").querySelector(".pricing-amount").classList.remove("disable");
      });

      //  update jeson for section click
      updatedTableConfig = upadteSectionTableJeson(tableConfig, sectionType, sectionIndex);

      setTargetSection();
      setTargetSectionIndex();
    }
    // handle click on item
    if (target.classList.contains("pricing-table-item-input")) {
      sectionIndex = targetId.split("-")[2];
      let itemIndex = targetId.split("-")[3];
      let itemType = targetId.split("-")[1] === "itemcheckbox" ? "checkbox" : "radio";

      //  update html for item click
      if (itemType === "checkbox") {
        let isChecked = document.getElementById(targetId).checked;
        if (isChecked) document.getElementById(targetId).removeAttribute("checked");
        else document.getElementById(targetId).setAttribute("checked", "");
        document.getElementById(targetId).checked = !isChecked;
      } else {
        let activeSection = document.getElementById(targetId).closest(".card-body");
        activeSection.querySelectorAll(".pricing-table-item-input").forEach(element => {
          element.checked = false;
          element.removeAttribute("checked");
        });
        document.getElementById(targetId).checked = true;
        document.getElementById(targetId).setAttribute("checked", "");
      }

      // disbale other item amount in html
      document.querySelectorAll(".pricing-table-item-input").forEach(element => {
        if (!element.checked)
          element.closest("ul").querySelector(".item-amount-details .pricing-amount").classList.add("disable");
        else element.closest("ul").querySelector(".item-amount-details .pricing-amount").classList.remove("disable");
      });

      //  update jeson for item click
      updatedTableConfig = upadteItemTableJeson(tableConfig, sectionIndex, itemType, itemIndex);

      setTargetSection(document.getElementById(targetId).closest(".pricing-table-section"));
      setTargetSectionIndex(Number(sectionIndex.slice(1)));
    }

    setTableConfigData(updatedTableConfig);
    setDiscountOptions({
      lineItemDiscount: tableConfig.lineItemDiscount,
      oneLineDiscount: tableConfig.oneLineDiscount,
      oneLineDiscountValue: tableConfig.oneLineDiscountValue,
      oneLineDiscountType: tableConfig.oneLineDiscountType,
    });
  };

  const getClosestSiblingWithSelector = (elem, selector) => {
    let prev = elem.previousElementSibling;
    let next = elem.nextElementSibling;

    while (prev || next) {
      if (prev && prev.matches(selector)) return prev;
      if (next && next.matches(selector)) return next;

      prev = prev?.previousElementSibling || null;
      next = next?.nextElementSibling || null;
    }

    return null; // No match found
  };

  const upadteSectionTableJeson = (tableConfig, sectionType, sectionIndex) => {
    let newTableConfig;
    sectionIndex = Number(sectionIndex.slice(1));

    if (sectionType === "checkbox") {
      newTableConfig = { ...tableConfig };
      newTableConfig.sections = [...tableConfig.sections];

      const section = {
        ...tableConfig.sections[sectionIndex],
        active: !tableConfig.sections[sectionIndex].active,
      };

      newTableConfig.sections[sectionIndex] = section;
    } else {
      newTableConfig = {
        ...tableConfig,
        sections: tableConfig.sections.map((section, index) => ({
          ...section,
          active: index === sectionIndex, // Only the target index is active
        })),
      };
    }
    return newTableConfig;
  };

  const upadteItemTableJeson = (tableConfig, sectionIndex, itemType, itemIndex) => {
    const newTableConfig = { ...tableConfig };
    sectionIndex = Number(sectionIndex.slice(1));
    itemIndex = Number(itemIndex.slice(1));

    if (itemType === "checkbox") {
      newTableConfig.sections = [...tableConfig.sections];
      newTableConfig.sections[sectionIndex] = {
        ...newTableConfig.sections[sectionIndex],
        items: [...tableConfig.sections[sectionIndex].items],
      };
      const item = newTableConfig.sections[sectionIndex].items[itemIndex];

      newTableConfig.sections[sectionIndex].items[itemIndex] = {
        ...item,
        active: !item.active,
      };
    } else {
      newTableConfig.sections = [...tableConfig.sections];
      const section = { ...newTableConfig.sections[sectionIndex] };

      // Map over items and update active state
      section.items = section.items.map((item, index) => ({
        ...item,
        active: index === itemIndex,
      }));

      newTableConfig.sections[sectionIndex] = section;
    }
    return newTableConfig;
  };

  const formattedCurrency = value => {
    let currentCurrency = currencyInfo.find(
      currency =>
        currency.name ===
        document.querySelector(`#${metadata.activeWidgetId[0]} .dhp-widget-inner`).getAttribute("data-currency")
    );

    const currencyValue = formatCurrency(
      value,
      getSymbolFromName(currentCurrency?.thousand_seperator),
      getSymbolFromName(currentCurrency?.decimal_seperator),
      currentCurrency?.decimal_places,
      currentCurrency?.number_format
    );
    return `${currentCurrency?.symbol} ${currencyValue}`;
  };

  // To format Currency
  function formatCurrency(
    value,
    thousandsSeparator = ",",
    decimalSeparator = ".",
    decimalPlaces = 2,
    numberFormat = "standard"
  ) {
    let [integer, decimal] = Number(value)?.toFixed(decimalPlaces).split("."); // Split the number into integer and decimal parts

    if (numberFormat === "indian") {
      const lastThree = integer.slice(-3);
      const rest = integer.slice(0, -3);

      integer = rest
        ? rest.replace(/\B(?=(\d{2})+(?!\d))/g, thousandsSeparator) + thousandsSeparator + lastThree
        : lastThree;
    } else {
      integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
    }

    return decimal ? `${integer}${decimalSeparator}${decimal}` : integer;
  }

  // To convert string into separator
  function getSymbolFromName(name) {
    const nameToSymbolMapping = { comma: ",", period: ".", space: " " };
    return nameToSymbolMapping[name];
  }

  const createTaxAreaHtml = taxes => {
    const container = document.getElementById("pricing-table-taxes");
    const totalAreaBackGroundColor =
      document.querySelector(".pricing-table-total").style.backgroundColor === ""
        ? hexToRGB("#4472c4")
        : document.querySelector(".pricing-table-total").style.backgroundColor;
    const backgroundColorRange = changeBucketColorAccordingBackground(totalAreaBackGroundColor);
    const taxColor = backgroundColorRange === "dark" ? "#ffffff" : "#000000";

    // Clear existing content
    container.innerHTML = "";

    taxes.forEach((tax, index) => {
      // Create main div
      const cardHeader = document.createElement("div");
      cardHeader.className = "d-flex justify-content-between align-items-center card-header";

      // Create left h6
      const taxName = document.createElement("h6");
      taxName.className = "mb-0 ml-4";
      taxName.innerHTML = `<!-- -->${tax.name}`;
      taxName.style.color = taxColor;

      // Create right h6 and amount div
      const amountWrapper = document.createElement("h6");
      amountWrapper.className = "mb-0";
      amountWrapper.style.color = taxColor;

      const amountDiv = document.createElement("div");
      amountDiv.className = `tax-amount-${index}`;
      amountDiv.textContent = tax.amount;

      // Nest elements
      amountWrapper.appendChild(amountDiv);
      cardHeader.appendChild(taxName);
      cardHeader.appendChild(amountWrapper);
      container.appendChild(cardHeader);
    });

    // update new height
    const innerEl = document.querySelector(`#${metadata.activeWidgetId} .dhp-widget-inner`);
    const outerEl = document.querySelector(`#${metadata.activeWidgetId}`);

    innerEl.style.height = "";
    const baseHeight = innerEl.offsetHeight;
    const transform = getComputedStyle(innerEl).transform;
    let scale = 1;

    if (transform && transform !== "none") {
      const match = transform.match(/matrix\(([^,]+),[^,]+,[^,]+,[^,]+,[^,]+,[^,]+\)/);
      if (match) {
        scale = parseFloat(match[1]);
      }
    }

    const scaledHeight = baseHeight * scale; // Calculate visual (scaled) height
    outerEl.style.height = `${scaledHeight}px`; // Apply scaled height to the outer container
    innerEl.style.height = `${baseHeight}px`;
    document.getElementById("dhp-widget-handler").style.height = `${getZoomedValue(scaledHeight, dimension.zoom)}px`; // apply height in widget handler
  };

  const handleQuantityInc = event => {
    let tableConfig = document.getElementById(metadata.activeWidgetId).getAttribute("data-table-config");
    tableConfig = JSON.parse(tableConfig);
    let itemIndex = Number(event.target.closest(".btn-increment").classList[4].split("-")[1]);
    let sectionIndex = Number(event.target.closest(".pricing-table-section").classList[3].split("-")[2]);
    let maxQuantity = tableConfig.sections[sectionIndex].items[itemIndex].maxQty;
    let quantity = tableConfig.sections[sectionIndex].items[itemIndex].data.quantity;
    let updatedQuantity = quantity + 1 > maxQuantity ? quantity : quantity + 1;

    // disable icon
    if (updatedQuantity === maxQuantity) event.target.closest(".btn-increment").classList.add("disable");
    event.target.closest(".input-group").querySelector(".btn-decrement").classList.remove("disable");

    if (quantity !== updatedQuantity) {
      event.target.closest(".input-group").querySelector(".form-control").innerHTML = updatedQuantity; // update html

      // update Jeson
      const newTableConfig = { ...tableConfig };
      newTableConfig.sections = [...tableConfig.sections];
      newTableConfig.sections[sectionIndex] = {
        ...newTableConfig.sections[sectionIndex],
        items: [...tableConfig.sections[sectionIndex].items],
      };
      const item = newTableConfig.sections[sectionIndex].items[itemIndex];

      // Copy the `data` object and update quantity
      const data = {
        ...item.data,
        quantity: updatedQuantity,
      };

      newTableConfig.sections[sectionIndex].items[itemIndex] = {
        ...item,
        data,
      };

      setTargetSection(event.target.closest(".pricing-table-section"));
      setTargetSectionIndex(sectionIndex);
      setTargetItem(event.target.closest("ul").querySelector(".item-amount-details .pricing-amount"));
      setTargetItemIndex(itemIndex);
      setTableConfigData(newTableConfig);
      setDiscountOptions({
        lineItemDiscount: tableConfig.lineItemDiscount,
        oneLineDiscount: tableConfig.oneLineDiscount,
        oneLineDiscountValue: tableConfig.oneLineDiscountValue,
        oneLineDiscountType: tableConfig.oneLineDiscountType,
      });
    }
  };

  const handleQuantityDec = event => {
    let tableConfig = document.getElementById(metadata.activeWidgetId).getAttribute("data-table-config");
    tableConfig = JSON.parse(tableConfig);
    let itemIndex = Number(event.target.closest(".btn-decrement").classList[4].split("-")[1]);
    let sectionIndex = Number(event.target.closest(".pricing-table-section").classList[3].split("-")[2]);
    let minQuantity = tableConfig.sections[sectionIndex].items[itemIndex].minQty;
    let quantity = tableConfig.sections[sectionIndex].items[itemIndex].data.quantity;
    let updatedQuantity = quantity - 1 < minQuantity ? quantity : quantity - 1;

    // disable icon
    if (updatedQuantity === minQuantity) event.target.closest(".btn-decrement").classList.add("disable");
    event.target.closest(".input-group").querySelector(".btn-increment").classList.remove("disable");

    if (quantity !== updatedQuantity) {
      event.target.closest(".input-group").querySelector(".form-control").innerHTML = updatedQuantity; // update html

      // update Jeson
      const newTableConfig = { ...tableConfig };
      newTableConfig.sections = [...tableConfig.sections];
      newTableConfig.sections[sectionIndex] = {
        ...newTableConfig.sections[sectionIndex],
        items: [...tableConfig.sections[sectionIndex].items],
      };
      const item = newTableConfig.sections[sectionIndex].items[itemIndex];

      // Copy the `data` object and update quantity
      const data = {
        ...item.data,
        quantity: updatedQuantity,
      };

      newTableConfig.sections[sectionIndex].items[itemIndex] = {
        ...item,
        data,
      };

      setTargetSection(event.target.closest(".pricing-table-section"));
      setTargetSectionIndex(sectionIndex);
      setTargetItem(event.target.closest("ul").querySelector(".item-amount-details .pricing-amount"));
      setTargetItemIndex(itemIndex);
      setTableConfigData(newTableConfig);
      setDiscountOptions({
        lineItemDiscount: tableConfig.lineItemDiscount,
        oneLineDiscount: tableConfig.oneLineDiscount,
        oneLineDiscountValue: tableConfig.oneLineDiscountValue,
        oneLineDiscountType: tableConfig.oneLineDiscountType,
      });
    }
  };

  useEffect(() => {
    if (calculatedSections && currencyInfo) {
      setTableConfigData();
      setDiscountOptions();

      let tableConfig = document.getElementById(metadata.activeWidgetId).getAttribute("data-table-config");
      tableConfig = JSON.parse(tableConfig);

      // format all currency
      let grandsubtotal = formattedCurrency(grandSubtotal);
      let onlelinedisamount = formattedCurrency(oneLineDiscountAmount);
      let detailstaxes = detailedTaxes.map(item => ({
        name: item.name,
        amount: formattedCurrency(item.amount),
      })); // Create new array with formatted amounts
      let grandtotal = formattedCurrency(grandTotal);

      // update new jeson with total, subtotal, sectioon total, tax etc
      let newObj = { ...tableConfig };
      newObj.sections = calculatedSections;
      newObj.subTotal = grandsubtotal;
      newObj.oneLineDiscountAmount = onlelinedisamount;
      newObj.detailedTaxes = detailstaxes;
      newObj.grandTotal = grandtotal;
      const jsonString = JSON.stringify(newObj);

      // update html
      if (targetSection) {
        let target = targetSection.querySelector(".section-total")
          ? targetSection.querySelector(".section-total")
          : targetSection.closest(".card-header").querySelector(".section-total");
        target.innerHTML = formattedCurrency(calculatedSections[targetSectionIndex].total);
      }
      if (targetItem) {
        targetItem.innerHTML = formattedCurrency(calculatedSections[targetSectionIndex].items[targetItemIndex].amount);
      }
      if (document.querySelector(`#${metadata.activeWidgetId} .grand-discount`))
        document.querySelector(`#${metadata.activeWidgetId} .grand-discount`).innerHTML = `- ${onlelinedisamount}`;
      if (document.getElementById("pricing-table-taxes")) createTaxAreaHtml(detailstaxes);
      document.querySelector(`#${metadata.activeWidgetId} .grand-subtotal`).innerHTML = grandsubtotal;
      document.querySelector(`#${metadata.activeWidgetId} .grand-total`).innerHTML = grandtotal;

      // update context
      let targetWidgetIndex = widgets.findIndex(widget => widget.id === metadata.activeWidgetId[0]);
      let newArray = Object.assign([...widgets]);
      newArray = Object.assign([...newArray], {
        [targetWidgetIndex]: {
          ...newArray[targetWidgetIndex],
          style: {
            ...newArray[targetWidgetIndex].style,
            height: document.getElementById(metadata.activeWidgetId).style.height,
          },
          data: {
            ...newArray[targetWidgetIndex].data,
            "data-table-config": jsonString,
          },
          innerHTML: document.getElementById(metadata.activeWidgetId[0]).innerHTML,
        },
      });
      updateWidgets(newArray);
      setTargetItem();
      setTargetItemIndex();
    }
  }, [calculatedSections, grandSubtotal, oneLineDiscountAmount, detailedTaxes, grandTotal]);

  useEffect(() => {
    if (metadata.activeWidgetType[0] !== PRICING_TABLE) return;

    dispatch(fetchProposalModuleList("currency", { page: 1, limit: 25 })).then(resp => {
      let currData = resp.results.data;
      setCurrencyInfo(currData);
    });
  }, [metadata.activeWidgetId]);

  useEffect(() => {
    if (metadata.activeWidgetType[0] !== PRICING_TABLE || document.querySelector(".pricing-table-modal")) return;

    const imageElements = document.querySelectorAll(".item-image");
    imageElements.forEach(el => {
      el.addEventListener("click", handleImageClick);
    });

    const checkBoxElem = document.querySelectorAll(".custom-checkbox");
    checkBoxElem.forEach(el => {
      el.addEventListener("click", handlePricingtableOptionClick);
    });

    const radioButtonElem = document.querySelectorAll(".custom-radio");
    radioButtonElem.forEach(el => {
      el.addEventListener("click", handlePricingtableOptionClick);
    });

    const incQuantity = document.querySelectorAll(".btn-increment");
    incQuantity.forEach(el => {
      el.addEventListener("click", handleQuantityInc);
    });

    const decQuantity = document.querySelectorAll(".btn-decrement");
    decQuantity.forEach(el => {
      el.addEventListener("click", handleQuantityDec);
    });

    // Cleanup on unmount
    return () => {
      imageElements.forEach(el => {
        el.removeEventListener("click", handleImageClick);
      });
      checkBoxElem.forEach(el => {
        el.removeEventListener("click", handlePricingtableOptionClick);
      });
      radioButtonElem.forEach(el => {
        el.removeEventListener("click", handlePricingtableOptionClick);
      });
      incQuantity.forEach(el => {
        el.removeEventListener("click", handleQuantityInc);
      });
      decQuantity.forEach(el => {
        el.removeEventListener("click", handleQuantityDec);
      });
    };
  });
};

export default usePricingTableEvent;
